export enum InputMaxChar {
  XXSMALL = 20,
  XSMALL = 40,
  SMALL = 100,
  MEDIUM = 160,
  LARGE = 300,
  XLARGE = 400,
  XXXLARGE = 900
}
